export const routeHandler = (model: string) => {
  let URL = "";
  switch (model) {
    case "auth":
      URL = "/auth";
      break;
    case "user":
      URL = "/users";
      break;
    case "clients":
      URL = "/clients";
      break;
    case "contacts":
      URL = "/contacts";
      break;
    case "clientDevices":
      URL = "/clients/devices";
      break;
    case "jobs":
      URL = "/jobs";
      break;
    case "counters":
      URL = "/counters";
      break;
    case "getNextNumber":
      URL = "/counters/next_number";
      break;
    case "serviceFee":
      URL = "/servicefee";
      break;
    case "addExpenses":
      URL = "/jobs/expenses/add";
      break;
    case "status":
      URL = "/status";
      break;
    case "timeline":
      URL = "/status/timeline";
      break;
    case "devices":
      URL = "/devices";
      break;
    case "devManu":
      URL = "/devices/manu";
      break;
    case "devDesc":
      URL = "/devices/desc";
      break;
    case "email":
      URL = "/email";
      break;
    case "zipcodes":
      URL = "/zipcodes";
      break;

    case "etalon":
      URL = "/etalons";
      break;

    case "etalonFunc":
      URL = "/etalons/functions";
      break;
    case "etalonParam":
      URL = "/etalons/params";
      break;
    case "deviceParam":
      URL = "/devices/params";
      break;
    case "deviceFunc":
      URL = "/devices/functions";
      break;
    case "employee":
      URL = "/employees";
      break;

    case "siprefix":
      URL = "/calibration/si_prefixes";
      break;
    case "units":
      URL = "/calibration/units";
      break;
    case "certificate":
      URL = "/calibration/certificate";
      break;
    case "certificateResults":
      URL = "/calibration/certificate/results";
      break;
  }
  return URL;
};
